type CognitoOAuthConfig = {
  authorizationServerUrl: string;
  poolId: string;
  clientId: string;
};

type UTurnConfig = {
  cognito: CognitoOAuthConfig | false;
};

const poolConfigKey = 'CognitoOAuthConfig';

export const initCognitoOAuthConfig = async (): Promise<void> => {
  const response = await fetch(`/config`);
  if (!response.ok) {
    throw new Error('Unable to fetch cognito pool config');
  }

  const config = (await response.json()) as UTurnConfig;

  if (!config.cognito) {
    throw new Error('UTurn config does not cotain a cognito config');
  }

  window.sessionStorage.setItem(poolConfigKey, JSON.stringify(config.cognito));
};

export const getCognitoOAuthConfig = (): CognitoOAuthConfig => {
  const poolConfigString = window.sessionStorage.getItem(poolConfigKey);

  if (poolConfigString) {
    return JSON.parse(poolConfigString) as CognitoOAuthConfig;
  }

  throw new Error('CognitoOAuthConfig is not initialized');
};
